
const fields = {
    broj_biopsije: {
        key: 'broj_biopsije',
        type: 'hInput',
        templateOptions: {
            label: 'Broj biopsije',
        }
    },
    primljeno: {
        key: 'primljeno',
        type: 'hCheckbox',
        templateOptions: {
            label: 'Primljeno',
        }
    },
    odgovoreno: {
        key: 'odgovoreno',
        type: 'hCheckbox',
        templateOptions: {
            label: 'Odgovoreno',
        }
    },
    oznaka_vanjske_biopsije: {
        key: 'oznaka_vanjske_biopsije',
        type: 'hInput',
        templateOptions: {
            label: 'Oznaka vanjske biopsije'
        }
    },
    napomena: {
        key: 'napomena',
        type: 'hTextarea',
        templateOptions: {
            label: 'Napomena',
            rows: 3,
            cols: 50,
        }
    },
    uputio: {
        key: 'uputio',
        type: 'hInput',
        templateOptions: {
            label: 'Uputio'
        }
    },
    dijagnoza_anamneza: {
        key: 'dijagnoza_anamneza',
        type: 'hTextarea',
        templateOptions: {
            label: 'Klinička dijagnoza (i Anamneza)',
            rows: 3,
            cols: 50,
        }
    },
    materijal: {
        key: 'materijal',
        type: 'hTextarea',
        templateOptions: {
            label: 'Materijal',
            rows: 3,
            cols: 50,
        }
    },
    lijecnik: {
        key: 'lijecnik',
        type: 'hInput',
        templateOptions: {
            label: 'Liječnik'
        }
    },
    tehnicar: {
        key: 'tehnicar',
        type: 'hInput',
        templateOptions: {
            label: 'Tehničar'
        }
    },
    pataloska_dijagnoza: {
        key: 'pataloska_dijagnoza',
        type: 'hTextarea',
        templateOptions: {
            label: 'Pataloška dijagnoza',
            rows: 3,
            cols: 50,
        }
    },
    pT_pN_pM: {
        key: 'pT_pN_pM',
        type: 'hInput',
        templateOptions: {
            label: 'pT: pN: pM:'
        }
    },
    prezime: {
        key: 'prezime',
        type: 'hInput',
        templateOptions: {
            label: 'Prezime',
            required: true
        }
    },
    ime: {
        key: 'ime',
        type: 'hInput',
        templateOptions: {
            label: 'Ime',
            required: true
        }
    },

    jmbg_oib: {
        key: 'jmbg_oib',
        type: 'hInput',
        templateOptions: {
            label: 'OIB'
        }
    },
    datum_rodjenja: {
        key: 'datum_rodjenja',
        type: 'hDatepicker',
        templateOptions: {
            label: 'Datum rođenja',
            required: true
        }
    },
    spol: {
        key: 'spol',
        type: 'hSelect',
        templateOptions: {
            label: 'Spol',
            options: [
                {value: 'M', name: 'Muški'},
                {value: 'Ž', name: 'Ženski'},
            ]
        }
    },
    dob: {
        key: 'dob',
        type: 'hInput',
        templateOptions: {
            label: 'Dob',
        }
    },
    sifra: {
        key: 'sifra',
        type: 'hInput',
        templateOptions: {
            label: 'Šifra'
        }
    },
    opis_nalaza_biopsije: {
        key: 'opis_nalaza_biopsije',
        type: 'textarea',
        templateOptions: {
            label: 'Opis nalaza biopsije',
            rows: 10,
            cols: 50,
        }
    }
};

export {fields};



// WEBPACK FOOTER //
// ./app/components/uputnica/form/fields.js